{
  "male": [
    "Grusk",
    "Thokk",
    "Krull",
    "Dench",
    "Gorth",
    "Rukk",
    "Drog",
    "Feng",
    "Gell",
    "Henk",
    "Holg",
    "Imsh",
    "Keth",
    "Mhurren",
    "Ront",
    "Shump",
    "Ugarth",
    "Varg",
    "Rakhul",
    "Gorzug",
    "Bolgar",
    "Durnak",
    "Karg",
    "Lurz",
    "Mog",
    "Narg",
    "Ozur",
    "Thrag",
    "Ulag",
    "Yashnag",
    "Agrom",
    "Azgar",
    "Barok",
    "Brugo",
    "Burzag",
    "Dagbur",
    "Dagrak",
    "Dragh",
    "Druzk",
    "Dulk",
    "Durz",
    "Ghamak",
    "Gnarsh",
    "Gogron",
    "Golbag",
    "Gorak",
    "Gorbag",
    "Gorkul",
    "Grak",
    "Gruk",
    "Gulfim",
    "Guldur",
    "Harrak",
    "Hruk",
    "Jorak",
    "Kazdor",
    "Kharag",
    "Khorg",
    "Korgan",
    "Krosh",
    "Krug",
    "Kurdan",
    "Larak",
    "Lugdush",
    "Lurgash",
    "Mabgar",
    "Mahk",
    "Maknok",
    "Malgar",
    "Mauhur",
    "Moghakh",
    "Morbash",
    "Mudrak",
    "Murbol",
    "Nagrum",
    "Narzul",
    "Nurbak",
    "Ogdum",
    "Olur",
    "Orgnolg",
    "Orzag",
    "Rogdul",
    "Rugdumph",
    "Shagrol",
    "Sharn",
    "Shazog",
    "Snagrot",
    "Tagrak",
    "Tharg",
    "Thorgan",
    "Thurbag",
    "Torg",
    "Ubrag",
    "Ughash",
    "Ulmug",
    "Umbrak",
    "Urgash",
    "Urzog",
    "Uzgar",
    "Vorgash",
    "Vrak",
    "Yamarz",
    "Yatur",
    "Zagh",
    "Zogar",
    "Zugrak",
    "Arkh",
    "Aruk",
    "Baddok",
    "Bazrag",
    "Borgakh",
    "Brakk",
    "Brogan",
    "Bruz",
    "Chakrul",
    "Dakhar",
    "Dorbag",
    "Duroth",
    "Durgash",
    "Eglar",
    "Gadrok",
    "Garmuk",
    "Ghash",
    "Ghorak",
    "Gorrum",
    "Grath",
    "Groth",
    "Gurak",
    "Haggar",
    "Hargrim",
    "Hogar",
    "Hruth",
    "Igmut",
    "Ishkar",
    "Jagrak",
    "Jhorn",
    "Kagar",
    "Kalthug",
    "Karrak",
    "Khazar",
    "Korth",
    "Kruk",
    "Kurgan",
    "Lakhar",
    "Lokar",
    "Lorgath",
    "Magrok",
    "Makhor",
    "Margok",
    "Morgrim",
    "Mukthar",
    "Nakhor",
    "Nargol",
    "Nazgrim",
    "Nukhul",
    "Obruk",
    "Ogrim",
    "Okkar",
    "Oroth",
    "Orrok",
    "Raghar",
    "Rashuk",
    "Rokhar",
    "Rothgar",
    "Ruzgul",
    "Sargath",
    "Shakar",
    "Shagar",
    "Skarn",
    "Sorgath",
    "Tarkul",
    "Teshak",
    "Thrukk",
    "Toruk",
    "Turgal",
    "Tuzgar",
    "Ughrak",
    "Ukthor",
    "Ulgrim",
    "Urkol",
    "Uthrag",
    "Vagrok",
    "Varzul",
    "Voshkar",
    "Yargul",
    "Yazbek",
    "Zarkh",
    "Zhorak",
    "Zurgath",
    "Bargul",
    "Bekh",
    "Bolkar",
    "Borr",
    "Dhorn",
    "Ezrak",
    "Garr",
    "Gerrak",
    "Gharn",
    "Gorb",
    "Grunk",
    "Halgar",
    "Harg",
    "Jarg",
    "Kesh",
    "Khurl",
    "Kordo",
    "Lagh",
    "Mokh",
    "Morr",
    "Ograk",
    "Orth",
    "Ragg",
    "Rhuk",
    "Sorr",
    "Tarsk",
    "Thrum",
    "Tusk",
    "Ulrik",
    "Vurg",
    "Zhak",
    "Akhrun",
    "Batur",
    "Chagatai",
    "Davvok",
    "Dumak",
    "Esen",
    "Gansukh",
    "Jebe",
    "Kaidu",
    "Khasar",
    "Nokhai",
    "Oktai",
    "Sukhbat",
    "Temur",
    "Toghrul",
    "Bayar",
    "Altan",
    "Barsuk",
    "Jochi",
    "Arslan",
    "Ashur",
    "Bukhar",
    "Dorgun",
    "Erdeg",
    "Ganzorig",
    "Orkhon",
    "Tumen",
    "Zhagir",
    "Ruhk",
    "Gharsh",
    "Hrogar",
    "Kordrak",
    "Mazgar",
    "Nurgash",
    "Orzhak",
    "Rakhash",
    "Shurak",
    "Torvak",
    "Urkh",
    "Vashnak",
    "Yugrash",
    "Zurok",
    "Brorg",
    "Dushnak",
    "Hulgar",
    "Kragmar",
    "Lugrim",
    "Mordak",
    "Ragnok",
    "Skorr",
    "Thuldak",
    "Varrok",
    "Wurgal",
    "Drokhar",
    "Gulgar",
    "Hurok",
    "Kazrak",
    "Morgash",
    "Ragash",
    "Ulgoth",
    "Zogrul",
    "Barg",
    "Durk",
    "Hakk",
    "Krag",
    "Ozgar",
    "Rokk",
    "Brug",
    "Gnash",
    "Korr",
    "Murg",
    "Thorg",
    "Urg",
    "Dak",
    "Brum",
    "Garak",
    "Bashar",
    "Korvak",
    "Shogar",
    "Gorun"
  ],
  "female": [
    "Brakka",
    "Urza",
    "Mogra",
    "Shagra",
    "Varga",
    "Yevra",
    "Oska",
    "Baggi",
    "Emen",
    "Bashka",
    "Batula",
    "Ghakka",
    "Neega",
    "Gharola",
    "Ownka",
    "Sutha",
    "Volen",
    "Lagakha",
    "Murzha",
    "Borba",
    "Dulfra",
    "Orbula",
    "Ugarra",
    "Atuba",
    "Gulza",
    "Oghula",
    "Sorkha",
    "Delgra",
    "Odvala",
    "Udvara",
    "Ulumpha",
    "Yazara",
    "Agrasha",
    "Akra",
    "Arga",
    "Bolora",
    "Azura",
    "Bagra",
    "Barza",
    "Batara",
    "Bolga",
    "Borgha",
    "Brasha",
    "Buzga",
    "Dagra",
    "Dakka",
    "Dushka",
    "Ekka",
    "Garma",
    "Ghasha",
    "Ghorza",
    "Gorra",
    "Grasha",
    "Grusha",
    "Gulda",
    "Gurza",
    "Hakka",
    "Harga",
    "Ishka",
    "Jagra",
    "Kagra",
    "Karza",
    "Kazga",
    "Kesha",
    "Khara",
    "Korga",
    "Krasha",
    "Kurza",
    "Lagra",
    "Lurza",
    "Makka",
    "Marza",
    "Morga",
    "Mozga",
    "Murga",
    "Nagra",
    "Narza",
    "Nazha",
    "Ogra",
    "Orsha",
    "Ozra",
    "Rakka",
    "Rasha",
    "Rogza",
    "Ruga",
    "Shakha",
    "Sharga",
    "Shazra",
    "Skarra",
    "Soka",
    "Tagra",
    "Tarza",
    "Thakka",
    "Thursa",
    "Ugra",
    "Ulga",
    "Umra",
    "Urga",
    "Ushka",
    "Uzra",
    "Vashka",
    "Vorga",
    "Vroka",
    "Yagra",
    "Yarza",
    "Zagra",
    "Zarga",
    "Zhora",
    "Zurka",
    "Agga",
    "Ashra",
    "Bakha",
    "Bralga",
    "Dorsha",
    "Druza",
    "Elga",
    "Esha",
    "Gazra",
    "Ghora",
    "Grukka",
    "Haza",
    "Irga",
    "Jorra",
    "Kaga",
    "Kosha",
    "Lokka",
    "Mazra",
    "Nokka",
    "Orza",
    "Rahza",
    "Rukka",
    "Shaza",
    "Tazha",
    "Tuga",
    "Ukka",
    "Vazha",
    "Yogra",
    "Zoka",
    "Aghra",
    "Bulka",
    "Durka",
    "Fegra",
    "Gorsha",
    "Huzka",
    "Igra",
    "Kalga",
    "Lugga",
    "Mogha",
    "Nurza",
    "Orka",
    "Puzha",
    "Raggha",
    "Sorga",
    "Thaka",
    "Uzga",
    "Yashka",
    "Zugra",
    "Arkha",
    "Bhurza",
    "Dazha",
    "Ghulna",
    "Hruska",
    "Ishra",
    "Khurza",
    "Mahra",
    "Noska",
    "Ragna",
    "Sakha",
    "Tolga",
    "Urska",
    "Veska",
    "Zhagra",
    "Altana",
    "Borte",
    "Khutulun",
    "Jargala",
    "Margha",
    "Yesui",
    "Mandukhai",
    "Ergene",
    "Toregene",
    "Saruna",
    "Altani",
    "Naran",
    "Saran",
    "Oyun",
    "Tuya",
    "Tsogza",
    "Undra",
    "Nomin",
    "Sarnai",
    "Amukka",
    "Eska",
    "Anara",
    "Solongo",
    "Enkhe",
    "Gerelma",
    "Zaya",
    "Erdene",
    "Ganna",
    "Hulan",
    "Tsetsa",
    "Khaliun",
    "Myeva",
    "Oyuna",
    "Shela",
    "Kansa",
    "Engra",
    "Zolzaya",
    "Brunna",
    "Dagny",
    "Hekka",
    "Ingra",
    "Kolka",
    "Lashra",
    "Morwa",
    "Ragga",
    "Sigra",
    "Torva",
    "Ugna",
    "Vrenna",
    "Yrsa",
    "Zorka",
    "Ashka",
    "Bruga",
    "Dagha",
    "Gerra",
    "Hrogna",
    "Jukka",
    "Korra",
    "Lazha",
    "Murka",
    "Ravna",
    "Skulda",
    "Thurga",
    "Ulka",
    "Varna",
    "Yolga",
    "Zhorka",
    "Ovakka",
    "Belgha",
    "Dolgra",
    "Yazga",
    "Grenna",
    "Hulka",
    "Irka",
    "Kezra",
    "Lurga",
    "Mezra",
    "Nyra",
    "Okha",
    "Rezka",
    "Sezka",
    "Tuzha",
    "Urna",
    "Vorna",
    "Wurka",
    "Zelga",
    "Brogha",
    "Gashka",
    "Kharra",
    "Mokha",
    "Nelga",
    "Orra",
    "Shurra",
    "Torga",
    "Yezra",
    "Zukka",
    "Asha",
    "Bezza",
    "Corra",
    "Durra",
    "Ezza",
    "Gezra",
    "Harra",
    "Ilsha",
    "Kezza",
    "Mura",
    "Nezza",
    "Ruzha",
    "Tezza",
    "Uzza",
    "Vira",
    "Zenna",
    "Garaka",
    "Khorra",
    "Brenga",
    "Olkha",
    "Rugha",
    "Shenra",
    "Thogra",
    "Volka",
    "Ghosha",
    "Draga",
    "Krenna",
    "Urgha",
    "Mahgra",
    "Shegra",
    "Tulga",
    "Durza"
  ],
  "family": [
    "Ironhide",
    "Skullsplitter",
    "Bonegnaw",
    "Redtusk",
    "Ashclaw",
    "Stonejaw",
    "Bloodfang",
    "Grimscar",
    "Blackmaw",
    "Thunderfist",
    "Blacktooth",
    "Bloodhammer",
    "Bonebreaker",
    "Brokenfang",
    "Burningblade",
    "Dragonmaw",
    "Frostwolf",
    "Shatterskull",
    "Thunderlord",
    "Warsong",
    "Blackrock",
    "Shadowmoon",
    "Laughingskull",
    "Stormreaver",
    "Blackfoot",
    "Blackhand",
    "Bonecrusher",
    "Boulderfist",
    "Broadaxe",
    "Burnscar",
    "Coldbrow",
    "Deathgrip",
    "Dirtfoot",
    "Earthshaker",
    "Firebrand",
    "Flintbreaker",
    "Goreclaw",
    "Greathorn",
    "Grimtotem",
    "Grimtusk",
    "Hammerfall",
    "Hollowfang",
    "Ironbrow",
    "Ironjaw",
    "Ironspike",
    "Irontusk",
    "Longspear",
    "Marrowgnaw",
    "Mountainfist",
    "Nightcrusher",
    "Oxhide",
    "Rageheart",
    "Redhand",
    "Ridgeback",
    "Rockbiter",
    "Rotfang",
    "Rustspear",
    "Scarback",
    "Shieldcleaver",
    "Skullcrusher",
    "Skyhammer",
    "Smokebrow",
    "Snowmane",
    "Spinebreaker",
    "Splitshield",
    "Steelhide",
    "Stonefist",
    "Stormfang",
    "Swiftaxe",
    "Tanglehorn",
    "Thornhide",
    "Thunderhoof",
    "Tuskbreaker",
    "Wolfrider",
    "Worldbreaker",
    "Yellowtusk",
    "Ashfang",
    "Ashhide",
    "Ashmaw",
    "Blackspear",
    "Bladecrag",
    "Bloodaxe",
    "Bloodmane",
    "Bloodtusk",
    "Boneclaw",
    "Bonehelm",
    "Bonetooth",
    "Boulderback",
    "Brasstusk",
    "Brimstone",
    "Brokenhorn",
    "Bronzejaw",
    "Burnhand",
    "Cinderclaw",
    "Cinderfist",
    "Cliffjaw",
    "Copperhide",
    "Crackskull",
    "Crowtusk",
    "Cragborn",
    "Cragfist",
    "Darkmane",
    "Deepscar",
    "Dreadaxe",
    "Dustwalker",
    "Duskfang",
    "Earthhide",
    "Emberfist",
    "Embermaw",
    "Emberscar",
    "Fellhammer",
    "Fenwolf",
    "Fireblood",
    "Firetusk",
    "Flamecaller",
    "Flintfist",
    "Flintjaw",
    "Foehammer",
    "Frostclaw",
    "Frostmane",
    "Frosttusk",
    "Gloomtusk",
    "Goldtusk",
    "Gorefist",
    "Gravelmaw",
    "Greyhide",
    "Greymaw",
    "Grimfang",
    "Grimhammer",
    "Grimjaw",
    "Grimspear",
    "Hailstrike",
    "Hardhide",
    "Hardtusk",
    "Hawkspear",
    "Hearthsmasher",
    "Heavyhand",
    "Highcliff",
    "Hillcrusher",
    "Hornbreaker",
    "Ironback",
    "Ironclaw",
    "Ironfang",
    "Ironmaw",
    "Ironwolf",
    "Jaggedtooth",
    "Keeneye",
    "Knuckledust",
    "Lashblade",
    "Longtusk",
    "Moonfang",
    "Mudhide",
    "Nightfang",
    "Oakbreaker",
    "Onetusk",
    "Pathcutter",
    "Plainsrunner",
    "Ravenshield",
    "Razorback",
    "Razorfang",
    "Redaxe",
    "Redclaw",
    "Redmane",
    "Redscar",
    "Rockhide",
    "Rocktusk",
    "Rumbleboot",
    "Rustfang",
    "Rustjaw",
    "Saberfist",
    "Sandhide",
    "Scarhand",
    "Scorchfist",
    "Shadowfang",
    "Sharpaxe",
    "Shieldbiter",
    "Skullcleaver",
    "Smashguard",
    "Smokefist",
    "Snapjaw",
    "Spearthrower",
    "Spiketusk",
    "Splitjaw",
    "Stonebiter",
    "Stonebreaker",
    "Stonehide",
    "Stormaxe",
    "Stormbrow",
    "Stormhide",
    "Stormtusk",
    "Strongarm",
    "Sunderblade",
    "Swordbreaker",
    "Tallspear",
    "Thickskull",
    "Thornfist",
    "Thundermaw",
    "Thunderhide",
    "Tidebreaker",
    "Torchbearer",
    "Trollbane",
    "Trueaxe",
    "Tuskhammer",
    "Twinblade",
    "Umberhide",
    "Wardrum",
    "Warhammer",
    "Warmaul",
    "Wartusk",
    "Wildmane",
    "Wolfbane",
    "Wolfjaw",
    "Wolftooth",
    "Wyrmslayer",
    "Yellowfang",
    "Bearslayer",
    "Beastcaller",
    "Bigtusk",
    "Blackblade",
    "Blackhide",
    "Bladefist",
    "Bloodmoon",
    "Bloodrage",
    "Bluetusk",
    "Bonefist",
    "Bonespear",
    "Boneshield",
    "Bouldertusk",
    "Bravetusk",
    "Briarhide",
    "Brightaxe",
    "Brokenshield",
    "Bullhorn",
    "Chainbreaker",
    "Cleftjaw",
    "Cloudsplitter",
    "Coalhide",
    "Crookfang",
    "Crushbone",
    "Darkfist",
    "Deadeye",
    "Deepdrum",
    "Direfang",
    "Doomcaller",
    "Dragonbone",
    "Drumbeater",
    "Dusttusk",
    "Earthbreaker",
    "Elkhorn",
    "Farstrider",
    "Fellclaw",
    "Fireheart",
    "Firehide",
    "Flatnose",
    "Flintspear",
    "Foamjaw",
    "Forgehand",
    "Frostbite",
    "Gatebreaker",
    "Ghostwolf",
    "Gnashtooth",
    "Goldmane",
    "Grassrunner",
    "Gravefist",
    "Greenhide",
    "Greenspear",
    "Grindjaw",
    "Halfhand",
    "Hammerhand",
    "Hardfist",
    "Hollowbone",
    "Hornfist",
    "Horsebreaker",
    "Howlwind",
    "Icefang",
    "Ironfoot",
    "Ironhand",
    "Ironheart",
    "Ironmane",
    "Ironspear",
    "Ironvein",
    "Jawbreaker",
    "Longaxe",
    "Mammothbane",
    "Mountainhide",
    "Nightblade",
    "Nighthowl",
    "Oathbreaker",
    "Oneeye",
    "Pelthide",
    "Proudtusk",
    "Quickaxe",
    "Ragewind",
    "Redblade",
    "Redfist",
    "Redhide",
    "Redmaw",
    "Ringhammer",
    "Rivercrusher",
    "Rockfist",
    "Rustmaw",
    "Saltjaw",
    "Scarfang",
    "Scarjaw",
    "Shadowhide",
    "Shardfist",
    "Silvertusk",
    "Skullbash",
    "Skullhelm",
    "Skyfang",
    "Sledgefist",
    "Smokehide",
    "Snowfang",
    "Soulfire",
    "Spearhand",
    "Spinetusk",
    "Splitbrow",
    "Steelfang",
    "Steeljaw",
    "Stonebrow",
    "Stoneclaw",
    "Stoneskull",
    "Stormcaller",
    "Stormjaw",
    "Sunfang",
    "Swiftspear",
    "Tallhorn",
    "Thornjaw",
    "Thunderaxe",
    "Thunderbrow",
    "Thunderspear",
    "Toothgrinder",
    "Totemkeeper",
    "Trailbreaker",
    "Twotusk",
    "Venomfang",
    "Vulturebane",
    "Warbringer",
    "Warcry",
    "Warfang",
    "Warhide",
    "Warmane",
    "Whitefang",
    "Whitemane",
    "Whitetusk",
    "Wildaxe",
    "Windrider",
    "Wolfheart",
    "Wolfmane",
    "Worgrider",
    "Wrathfist",
    "Gro-Bagol",
    "Gro-Durash",
    "Gro-Lurz",
    "Gro-Mash",
    "Gro-Shug",
    "Gro-Khazor",
    "Gro-Ulag",
    "Gra-Bolga",
    "Gra-Shuzog",
    "Gra-Murz",
    "Gra-Ushka",
    "Bolgakh",
    "Durzagh",
    "Gorzash",
    "Kharzug",
    "Mozgul",
    "Nargash",
    "Orzhul",
    "Shugrak",
    "Ulgash",
    "Uzkhar",
    "Varzhul",
    "Yagrum",
    "Zugdul",
    "Brokentooth",
    "Carvedtusk",
    "Coldfang",
    "Crackjaw",
    "Deathwind",
    "Dreadmane",
    "Dunehide",
    "Eaglespear",
    "Emberhide",
    "Firefist",
    "Flamejaw",
    "Frostfist",
    "Gloomhide",
    "Grimbrow",
    "Hailfist",
    "Hornhide",
    "Ironbelly",
    "Ironbone",
    "Kneebreaker",
    "Lakewalker",
    "Longstride",
    "Mawbreaker",
    "Mirestrider",
    "Nighteye",
    "Notchedaxe",
    "Palehide",
    "Peakbreaker",
    "Quarrelfist",
    "Rainhammer",
    "Redstone",
    "Rimehide",
    "Rivertusk",
    "Rubbletusk",
    "Sandfang",
    "Scorchmane",
    "Shatterfist",
    "Shieldmaw",
    "Skullfist",
    "Slatefist",
    "Slatejaw",
    "Snowhide",
    "Steppewind",
    "Stonemaw",
    "Anvilbrow",
    "Ashenmaw",
    "Badgerhide",
    "Bearclaw",
    "Bitterfang",
    "Blackscar",
    "Blizzardmane",
    "Bloodstone",
    "Boarhide",
    "Boartusk",
    "Bramblejaw",
    "Brandscar",
    "Bullneck",
    "Cairnbreaker",
    "Canyonfist",
    "Cragmaw",
    "Crowbane",
    "Cutjaw",
    "Dawnhowl",
    "Dreadtusk",
    "Dunewalker",
    "Duskhide",
    "Eaglebane",
    "Fangborn",
    "Fellhide",
    "Flintback",
    "Gallowtusk",
    "Graniteback",
    "Graveltusk",
    "Greatjaw",
    "Grimhowl",
    "Hawkbane",
    "Hillborn",
    "Hoarfrost",
    "Hornspear",
    "Ironroar",
    "Jadetusk",
    "Knotfist",
    "Lavafist",
    "Lonespear",
    "Marshhide",
    "Mightfist",
    "Moonhowl",
    "Mosshide",
    "Oxbreaker",
    "Ploughfist",
    "Quakefoot",
    "Ramhorn",
    "Redwind",
    "Ridgehide",
    "Rimefang",
    "Roarmaw",
    "Rockmaw",
    "Runefang",
    "Saltmane",
    "Scarbrow",
    "Scorchtusk",
    "Shalehide",
    "Shatterjaw",
    "Shieldfist",
    "Skyhowl",
    "Slagfist",
    "Smeltfist",
    "Sootmane",
    "Spearbrow",
    "Stagbane",
    "Steelbrow",
    "Stonewall",
    "Stormhowl",
    "Sunscar",
    "Tarhide",
    "Thornback",
    "Thunderborn",
    "Torchfist",
    "Tuskborn",
    "Valleyfist",
    "Wargfang",
    "Wildhowl",
    "Wolfborn",
    "Yokebreaker",
    "Ashborn",
    "Bloodborn"
  ],
  "gendered": {
    "male": [
      "Gro-Bagol",
      "Gro-Durash",
      "Gro-Lurz",
      "Gro-Mash",
      "Gro-Shug",
      "Gro-Khazor",
      "Gro-Ulag"
    ],
    "female": [
      "Gra-Bolga",
      "Gra-Shuzog",
      "Gra-Murz",
      "Gra-Ushka"
    ]
  }
}
